import React, { useState } from 'react'
import {
    Paper, IconButton,
    MenuItem,
    Menu,
    Stack, Button,
    InputBase
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Search } from '@mui/icons-material';
import { Filter } from '../../../Svg';
import { setScheduleOrderFromDate, setScheduleSearch, setScheduleOrderToDate } from '../../../redux/scheduledOrders';
import { useDispatch } from 'react-redux';
import Calendar from 'react-calendar';
import { formateDate } from '../../../utils/fomateDate';

const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '0.875rem',
    color: '#512DA8',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    borderRadius: '8px',
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));


const SearchInput = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    width: '320px',
    fontFamily: `'Public Sans', sans-serif`,
}));


const status = ['NEW', 'PENDING', 'RESCHEDULE','CANCELLED','COMPLETED']


const ScheduleOrderFilter = ({ search, setAllStatus, selectedTab }) => {
    const dispatch = useDispatch()
    const [catAnchorEl, setCatAnchorEl] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);

    const [statusAnchorEl, setStatusAnchorEl] = useState(null);
    const statusOpen = Boolean(statusAnchorEl);


    // Handlers for Category dropdown
    const handleCatClick = (event) => {
        setCatAnchorEl(event.currentTarget);
    };

    const handleStatusClick = (event) => {
        setStatusAnchorEl(event.currentTarget);
    };

    const handleStatusClose = (status) => {
        if (status) {
         const   statuss = status ==  "NEW" ? "APPROVED" : status
            setAllStatus(statuss)
        }
        setStatusAnchorEl(null);
    };

    const handleCalenderData = (e) => {
        dispatch(setScheduleOrderFromDate(formateDate(e)));
        dispatch(setScheduleOrderToDate(formateDate(e)));
        setShowCalendar(!showCalendar)
    }


    return (

        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ paddingBottom: '20px' }} marginTop={2.5}>
            <SearchInput>
                <IconButton aria-label="search">
                    <Search />
                </IconButton>
                <InputBase placeholder="Search…" onChange={(e) => dispatch(setScheduleSearch(e.target.value))} value={search} />
            </SearchInput>

            <div style={{ display: 'flex' }}>
                {/* Category Dropdown */}
                <div>
                    <ActionButton
                        onClick={()=>setShowCalendar(true)}
                        sx={{
                            color: '#667085',
                            border: '1px solid #E0E2E7',
                            background: '#fff',
                            borderRadius: '8px',
                        }}
                    >
                        <Filter /> Calender
                    </ActionButton>
                    {showCalendar && (
                        <div className="calender">
                            <Calendar onChange={(e) => handleCalenderData(e)} />
                        </div>
                    )}
                </div>

                {/* Status Dropdown */}
                {selectedTab == 0 ?
                    <div>
                        <ActionButton
                            onClick={handleStatusClick}
                            sx={{
                                color: '#667085',
                                border: '1px solid #E0E2E7',
                                background: '#fff',
                                borderRadius: '8px',
                            }}
                        >
                            <Filter /> Status
                        </ActionButton>
                        <Menu
                            anchorEl={statusAnchorEl}
                            open={statusOpen}
                            onClose={() => handleStatusClose('')}
                            MenuListProps={{
                                'aria-labelledby': 'status-button',
                            }}
                        >
                            {status?.map((i) => (

                                <MenuItem onClick={() => handleStatusClose(i)}
                                    sx={{
                                        borderBottom: '1px solid #E6E1E5',
                                        fontSize: '14px',
                                        color: '#667085',
                                    }}>{i}
                                </MenuItem>
                            ))
                            }
                        </Menu>
                    </div>
                    : null}
            </div>
        </Stack>
    )
}

export default ScheduleOrderFilter